import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["error"];
import { memoizeDeep } from "../common/utilities";
const setTheme = memoizeDeep(function (_ref) {
  let {
    multiSelect
  } = _ref;
  let buttonErrorCSS = {},
      multiSelectRoot = {},
      subGroupIconCSS = {},
      multiSelectFooterCSS = {},
      multiSelectFooterErrorCSS = {},
      multiSelectLabelErrorCSS = {},
      multiSelectMenuCSS = {},
      multiSelectWrapperStyles = {},
      buttonCSS = {},
      multiSelectLabelCSS = {},
      multiSelectOpenedCSS = {},
      multiSelectLabelInlineCSS = {},
      multiSelectLabelNoEllipsisCSS = {},
      instructionalTextCSS = {},
      menuItemGroupCSS = {},
      menuItemCSS = {},
      menuItemDisabledCSS = {},
      menuItemSelectedCSS = {},
      menuItemWrapCSS = {},
      hintCSS = {};

  if (multiSelect) {
    multiSelectRoot = multiSelect.root;
    subGroupIconCSS = multiSelect.subGroupIconCSS;
    multiSelectMenuCSS = multiSelect.multiSelectMenuCSS;
    multiSelectWrapperStyles = multiSelect.multiSelectWrapperStyles;
    buttonCSS = multiSelect.buttonCSS;
    buttonErrorCSS = multiSelect.buttonCSS.error;
    multiSelectLabelCSS = multiSelect.multiSelectLabelCSS;
    multiSelectLabelErrorCSS = multiSelect.multiSelectLabelCSS.error;
    multiSelectOpenedCSS = multiSelect.multiSelectOpenedCSS;
    multiSelectLabelInlineCSS = multiSelect.multiSelectLabelInlineCSS;
    multiSelectLabelNoEllipsisCSS = multiSelect.multiSelectLabelNoEllipsisCSS;
    menuItemGroupCSS = multiSelect.menuItemGroupCSS;
    instructionalTextCSS = multiSelect.instructionalTextCSS;
    menuItemCSS = multiSelect.menuItemCSS;
    menuItemDisabledCSS = multiSelect.menuItemDisabledCSS;
    menuItemWrapCSS = multiSelect.menuItemWrapCSS;
    menuItemSelectedCSS = multiSelect.menuItemSelectedCSS;
    hintCSS = multiSelect.hintCSS;

    const _multiSelect$footer = multiSelect.footer,
          {
      error: errorFooterStyles
    } = _multiSelect$footer,
          commonFooterStyles = _objectWithoutProperties(_multiSelect$footer, _excluded);

    multiSelectFooterCSS = commonFooterStyles;
    multiSelectFooterErrorCSS = errorFooterStyles;
  }

  return {
    multiSelectRoot,
    subGroupIconCSS,
    multiSelectMenuCSS,
    multiSelectWrapperStyles,
    buttonCSS,
    buttonErrorCSS,
    multiSelectFooterCSS,
    multiSelectFooterErrorCSS,
    multiSelectLabelCSS,
    multiSelectLabelErrorCSS,
    multiSelectOpenedCSS,
    multiSelectLabelInlineCSS,
    multiSelectLabelNoEllipsisCSS,
    menuItemGroupCSS,
    instructionalTextCSS,
    menuItemCSS,
    menuItemDisabledCSS,
    menuItemWrapCSS,
    menuItemSelectedCSS,
    hintCSS
  };
});
export default function (_ref2) {
  var _theme$components;

  let {
    theme
  } = _ref2;
  const multiSelect = theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : _theme$components.multiselect;
  return setTheme({
    multiSelect
  });
}